import React from "react"
import Link from "gatsby-link"

import style from "./index.module.css";

export default class BlockList extends React.Component {
  render() {
    var items = this.props.items;
    return (
      <div className={style.list}>
        {items && items.map((item) => {
          return (
            <article key={item.id} className={style.item}>
              <Link to={item.link ? item.link : ""}>
                {item.title &&
                  <h1 className={style.title}>{item.title}</h1>
                }
                {item.text.text &&
                  <div className={style.text}>{item.text.text}</div>
                }
              </Link>
              {(item.linkTitle && item.link) &&
                <Link className={style.linkMargin} to={item.link}>{item.linkTitle}</Link>
              }
            </article>
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BlockList/index.js